// extracted by mini-css-extract-plugin
export default {"typeahead":"AddressTypeAhead--typeahead--OJg9O"};